import { IPageGroupConfig, IFrameworkConfig } from "./IConfiguration";

/* Product Constants */

var pageGroups: IPageGroupConfig[];
var classifications: string[];
var appConfig: IFrameworkConfig;

if (process.env.PRODUCT === "platypus") {
    pageGroups = require("./Platypus").PageGroups;
    appConfig = require("./Platypus").AppConfig;
}

if (process.env.PRODUCT === "carp") {
}

if (process.env.PRODUCT === "feralscan") {
    pageGroups = require("./Feralscan").PageGroups;
    appConfig = require("./Feralscan").AppConfig;
}


export const PageGroups: IPageGroupConfig[] = pageGroups;
export const Classifications = classifications;
export const AppConfig = appConfig;